import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mt-5",
    attrs: {
      "title": "Observações"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Observação",
      "label-for": "observacao"
    }
  }, [_c(VTextarea, {
    attrs: {
      "full-width": "",
      "rows": "3"
    },
    model: {
      value: _vm.form.observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacao", $$v);
      },
      expression: "form.observacao"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };